import { GetCategoriesIcon, GetSportIcon } from 'assets/icons';
import { NavLink } from 'react-router-dom';
import { generateUrl } from 'shared/util/generateUrl';
import { CategoryDataInterface } from '../../interface';

interface NavigationItemProps {
	item: CategoryDataInterface;
	iconType: 'sport' | 'category' | 'sport|category';
}

const NavigationItem = ({ item, iconType }: NavigationItemProps) => (
	<NavLink className="navigation__item" to={generateUrl(item)} data-cy="left-tree-item" rel={item.disableNoFollow ? undefined : 'nofollow'}>
		{iconType.includes('sport') && <GetSportIcon id={item.sportId} className="navigation__icon" />}
		{iconType.includes('category') && <GetCategoriesIcon category={item} className="navigation__icon" />}
		<span className="word__wrap">{item.categoryName}</span>
		<span className="navigation__count">{item.eventsCount}</span>
	</NavLink>
);

export default NavigationItem;
